"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class TaskController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/case/:objectId/task',
            edit: '/v1/task/:objectId',
            delete: '/v1/task/:objectId',
            markActionAsRequired: '/v1/task/:taskId/actionRequired/:orgId',
            markActionAsDone: '/v1/task/:taskId/actionDone/:orgId',
            bulkEdit: '/v1/task/_bulk',
            addShare: '/v1/task/:taskId/shares',
            deleteShare: '/v1/task/:taskId/shares',
        };
    }
    markActionAsRequired(taskId, orgId) {
        return this.manager.put({
            url: this.endpoints.markActionAsRequired,
            params: {
                taskId,
                orgId,
            },
        });
    }
    markActionAsDone(taskId, orgId) {
        return this.manager.put({
            url: this.endpoints.markActionAsDone,
            params: {
                taskId,
                orgId,
            },
        });
    }
    addShare(organisations, taskId) {
        return this.manager.post({ url: this.endpoints.addShare, params: { taskId } }, { organisations });
    }
    deleteShare(organisations, taskId) {
        return this.manager.delete({ url: this.endpoints.deleteShare, params: { taskId } }, { organisations });
    }
}
exports.default = TaskController;
